import { defineComponent as _defineComponent } from 'vue'
import ToggleContent from '../toggle-content/toggle-content.vue';

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'b-ticket-travel-insurance-contact-information',
  props: {
  product: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;

// Components


return { __sfc: true,props, ToggleContent }
}

})